import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.8rem 10rem;
  
  background-color: var(--terminal-bg);
  border-bottom: 1px solid var(--terminal-border);
  backdrop-filter: blur(10px);

  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1000;
  font-family: 'Fira Code', monospace;

  .logo {
    color: var(--green);
    font-size: 2.2rem;
    font-weight: 700;
    display: flex;
    gap: 0.5rem;
  }

  .status-indicator {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.2rem;
    color: #6a737d;
    background: var(--terminal-header);
    padding: 0.4rem 1.2rem;
    border-radius: 2rem;
    border: 1px solid var(--terminal-border);

    .dot {
      width: 8px;
      height: 8px;
      background: var(--green);
      border-radius: 50%;
      box-shadow: 0 0 10px var(--green);
    }
  }

  nav{
    display: flex;
    align-items: center;
    gap: 1rem;
    
    a{
      color: #d1d5db;
      padding: 0.8rem 1.4rem;
      font-size: 1.4rem;
      font-weight: 500;
      border-radius: 4px;
      transition: 0.2s;

      &:hover{
        background: var(--terminal-header);
        color: var(--green);
      }

      &.button{
        background: var(--green);
        color: #FFF;
        margin-left: 1rem;
        &:hover {
          filter: brightness(0.9);
        }
      }
    }
  }

  .menu{
    width: 2.5rem;
    height: 0.2rem;
    background: var(--green);
    position: relative;
    cursor: pointer;
    display: none;

    &:before, &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 0.2rem;
      background: var(--green);
      transition: 0.3s;
    }

    &:before{ bottom: 0.8rem; }
    &:after{ top: 0.8rem; }

    &.active {
      background: transparent;
      &:before {
        bottom: 0;
        transform: rotate(45deg);
      }
      &:after {
        top: 0;
        transform: rotate(-45deg);
      }
    }
  }

  @media (max-width: 960px){
    padding: 1.8rem 3rem;

    .status-indicator {
      display: none;
    }

    .menu{
      display: block;
    }

    nav {
      opacity: 0;
      visibility: hidden;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: fixed;
      width: 100vw;
      height: 100vh;
      background: var(--terminal-bg);
      top: 0;
      left: 0;
      transition: 0.3s;
      gap: 3rem;

      a {
        font-size: 2.4rem;
      }

      &.active{
        opacity: 1;
        visibility: visible;
      }
    }
  }
`;
